import { Pipe, PipeTransform } from '@angular/core';
import { SortObj } from 'src/app/shared/models/sort-object.model';

@Pipe({
  name: 'sortByProp',
  standalone: false
})
export class ArraySortByPropPipe implements PipeTransform {
  public transform(array: any, fieldOrSortObj: string | SortObj, isReverse = false): any[] {
    let field: string;

    if (typeof fieldOrSortObj === 'string') {
      field = fieldOrSortObj;
    } else {
      field = fieldOrSortObj.sortedProp;
      isReverse = fieldOrSortObj.isReverseSorting;
    }

    if (!Array.isArray(array)) {
      return;
    }

    array = array.slice().sort((a: any, b: any) => {
      let item1 = a[field];
      let item2 = b[field];

      if (item1 === null) {
        return isReverse ? 1 : -1;
      }

      if (item2 === null) {
        return isReverse ? -1 : 1;
      }

      if (typeof item1 === 'string') {
        item1 = item1.toLowerCase().trim();
      }

      if (typeof item2 === 'string') {
        item2 = item2.toLowerCase().trim();
      }

      if (item1 < item2) {
        return isReverse ? 1 : -1;
      } else if (item1 > item2) {
        return isReverse ? -1 : 1;
      } else {
        return 0;
      }
    });

    return array;
  }
}
